import React, { useState } from "react";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import { Link } from "react-router-dom";
import img from "../assets/images/landing-page/collection-banner-carousel--collection-cover-art.png";
import logo from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";
import img1 from "../assets/images/Collection/artwork-1.png";
import Tabs from "../Components/Tabs";

const ItemDetails = ({
  prevStep,
  nextStep,
  handleChange,
  values,
  selectItem,
  removeItems,
}) => {
  const Continue = (e) => {
    e.preventDefault();
    nextStep();
  };

  const Previous = (e) => {
    e.preventDefault();
    prevStep();
  };

  const getImageAsData = (image) => {
    if (!!image) {
      return URL.createObjectURL(image);
    } else {
      return "";
    }
  };

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <nav className="navbar navbar-light justify-content-between">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="logo" /> Lorem
        </Link>
        <div className="justify-content-between">
          {/* <Link to="#"><i className="fa fa-search" aria-hidden="true"></i></Link>&emsp;
                    <Link to="/Drops">Drops</Link>&emsp;
                    <Link to="/Marketplace">Marketplace </Link> */}
          <div className="dropdown">
            <button className="dropbtn">
              <i className="fa fa-user" aria-hidden="true"></i>
            </button>
            <div className="dropdown-content text-left">
              <Link to="/AccountInfo">Account Info</Link>
              <Link to="/AccountActivityBuyer">Account Activity</Link>
              <Link to="#">Connect Wallet</Link>
              <Link to="/UserProfileBuyer">Buyer Profile</Link>
              <Link to="/CollectionDetails">Add New Collections</Link>
              <Link to="/LoginSignup">Login</Link>
            </div>
          </div>
        </div>
      </nav>
      {/* Header area end */}

      {/* Form area start */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center form-area">
            <h1 className="text-center">Submit New Collection</h1>

            {/* Progressbar start */}
            <ul id="progress-bar" className="progressbar">
              <li className="active">COLLECTION</li>
              <li className="active">UPLOAD ITEMS</li>
              <li className="active">ITEM DETAILS</li>
              <li>REVIEW & SUBMIT</li>
            </ul>
            {/* Progressbar end */}
          </div>
        </div>
      </div>

      {/* multistep form start*/}
      <div className="container text-center margin-70 arrow">
        <button onClick={Previous}>&#10229;</button>
        <h1>
          Item Details
          <br />
          <span>{values.collectionTitle}</span>
        </h1>
        <button onClick={Continue}>&#10230;</button>
      </div>
      <div className="container mb-5">
        <div className="text-left uploaded">
          {values.items.length > 0 ? (
            <h6>
              {values.items.length} Files Uploaded{" "}
              <span style={{ cursor: "pointer" }} onClick={removeItems}>
                Remove All
              </span>
            </h6>
          ) : null}
          {values.items.map((item, index) => {
            return (
              <img
                onClick={() => selectItem(item, index)}
                src={getImageAsData(item.image)}
                key={index}
                alt=""
              />
            );
          })}
        </div>
        <div className="row upload-item-details">
          <div className="col-lg-6 text-left">
            {!!values.selectedItem ? (
              <img src={getImageAsData(values.selectedItem.image)} alt="" />
            ) : null}
            <h5>
              <span>Remove All</span>
            </h5>
            <h6>Note</h6>
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
              nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
              erat volutpat. Ut wisi enim ad minim veniam,
            </p>
          </div>
          <div className="col-lg-6 text-left item-detail-area">
            <h1>Item Title</h1>
            <input
              onChange={handleChange("item-title")}
              value={values.selectedItem.title}
              type="text"
              placeholder="e.g. Lorem Ipsum"
            ></input>
            <h1>Description</h1>
            <p>
              {values.selectedItem.description.length} of 1000 characters used
            </p>
            <textarea
              maxlength="1000"
              onChange={handleChange("item-description")}
              type="text"
              rows="3"
              placeholder="Provide a description of your collection."
              value={values.selectedItem.description}
            ></textarea>
            <h1>Edition(s)</h1>
            <p>Number of Editions</p>
            <input
              onChange={handleChange("item-edition")}
              type="text"
              placeholder="1000"
              value={values.selectedItem.edition}
            ></input>
            <h1>Sell Method</h1>
            <Tabs
              selectSellMethodFixed={handleChange("sell-method-fixed")}
              selectSellMethodBid={handleChange("sell-method-bid")}
              sellMethod={
                values.selectedItem.sellMethod === "fixed"
                  ? "Fixed Price"
                  : "Highest Bid"
              }
            >
              <div className="fixed-price" label="Fixed Price">
                <p>Enter your ﬁxed price in ETH</p>
                <input
                  onChange={handleChange("item-fixed-price")}
                  value={values.selectedItem.fixedPrice}
                  type="text"
                  placeholder="0.01"
                ></input>
              </div>
              <div className="Highest Bid" label="Highest Bid">
                <p>Enter the bid starting price in ETH</p>
                <input
                  onChange={handleChange("item-fixed-price")}
                  value={values.selectedItem.fixedPrice}
                  type="text"
                  placeholder="0.01"
                ></input>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
      {/* multistep form end*/}

      {/* Form area end */}
    </div>
  );
};

export default ItemDetails;
